"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _KeyboundComponent = require("../KeyboundComponent");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var CountKeys = (0, _createReactClass.default)({
  displayName: "CountKeys",
  propTypes: {
    className: _propTypes.default.string,
    registerListener: _propTypes.default.func
  },
  getInitialState: function getInitialState() {
    return {
      cmdA: 0,
      cmdB: 0,
      cmdShiftA: 0,
      cmdShiftB: 0,
      shiftA: 0,
      backspace: 0
    };
  },
  componentDidMount: function componentDidMount() {
    var _this = this;

    var registerListener = this.props.registerListener;
    registerListener('cmd+a', this.incrementCmdA, this);
    registerListener('b+ctrl', function () {
      return _this.setState({
        cmdB: _this.state.cmdB + 1
      });
    });
    registerListener('command+shift+a', function () {
      return _this.setState({
        cmdShiftA: _this.state.cmdShiftA + 1
      });
    });
    registerListener('shift+control+b', function () {
      return _this.setState({
        cmdShiftB: _this.state.cmdShiftB + 1
      });
    });
    registerListener('A+Shift', function () {
      return _this.setState({
        shiftA: _this.state.shiftA + 1
      });
    });
    registerListener('backspace', function (e) {
      // callbacks are passed the original event, so you can do normal
      // event things like prevent default behavior
      e.preventDefault();

      _this.setState({
        backspace: _this.state.backspace + 1
      });
    });
  },
  incrementCmdA: function incrementCmdA() {
    this.setState({
      cmdA: this.state.cmdA + 1
    });
  },
  render: function render() {
    var _this$state = this.state,
        cmdA = _this$state.cmdA,
        cmdB = _this$state.cmdB,
        cmdShiftA = _this$state.cmdShiftA,
        cmdShiftB = _this$state.cmdShiftB,
        shiftA = _this$state.shiftA,
        backspace = _this$state.backspace;
    return _react.default.createElement("div", {
      className: this.props.className
    }, _react.default.createElement("h3", {
      id: "command-a"
    }, cmdA), _react.default.createElement("h3", {
      id: "command-b"
    }, cmdB), _react.default.createElement("h3", {
      id: "command-shift-a"
    }, cmdShiftA), _react.default.createElement("h3", {
      id: "command-shift-b"
    }, cmdShiftB), _react.default.createElement("h3", {
      id: "shift-a"
    }, shiftA), _react.default.createElement("h3", {
      id: "backspace"
    }, backspace));
  }
});

var _default = (0, _KeyboundComponent.KeyboundComponent)(CountKeys);

exports.default = _default;
module.exports = exports.default;